import { sortedByNumber } from "../utils";

export const handleAllAddonsWithOld = (
  allAddonCategories,
  appState,
  product,
  cartId
) => {
  let add = [];
  let total = 0;
  let newArr = [...allAddonCategories];
  let addonsInfo = [];
  let detailAddons = [];
  let arryAddonLimit = [];
  
  let localAddons = appState.cart.find((x) => x.id == cartId)?.addons;

  if (localAddons) {
    localAddons.forEach((localAddonItems) => {
      if (localAddonItems.product_id == product.id) {
        localAddonItems.total = function () {
          return this.quantity * this.price;
        };
        add.push(localAddonItems);
        total += localAddonItems.total();
      }
    });
  }

  if (newArr && newArr.length > 0) {
    newArr.forEach((element) => {
    if(element?.status){
      let has_addons = false
      let objAddonLimit = {
        id: element.id,
        title: element.title,
        limit: element.limit || null,
        min: element.min || null,
        max: element.max || null,
        unique: element.unique || 0,
        required: element.required || null,
        addons_qty: 0,
        addons_length: element.product_addons.length,
        addons_category_name:element.category.name,
        order:element?.order ?? null
      };


      element.product_addons.forEach((addonItem) => {
        let found = add.some((ele) => ele.product_addon_id === addonItem.id);
        if(addonItem?.addon?.status)
       {
        let inActive = appState.deliveryMode ? addonItem?.addon?.inactive_delivery_branches : appState.pickupMode ? addonItem?.addon?.inactive_pickup_branches : addonItem?.addon?.inactive_branches ?? [];
        has_addons = inActive?.includes(appState.qrBranch) ? false : true;
        let show =  has_addons ;
        if(show){
          const visibleAfterDate = new Date(show);
          const currentDate = new Date();
          show = visibleAfterDate <= currentDate;
        }

        if(show && addonItem?.visible_after){
          const visibleAfterDate = new Date(addonItem?.visible_after);
          const currentDate = new Date();
          
          // Check if the date is valid before comparison
          if (!isNaN(visibleAfterDate.getTime())) {
            show = visibleAfterDate <= currentDate;
          } else {
            // If date is invalid, default to showing the product
            show = true;
          }
        }

        if(show){
        const data = {
          show_image: element?.show_image,
          category_addon_id: element.id,
          product_addon_id: addonItem.id,
          required: element.required || null,
          min: element.min || null,
          max: element.max || null,
          unique: element.unique || 0,
          addon: addonItem.addon,
          description: addonItem.description,
          price: addonItem.price,
          maxQuantity: addonItem.quantity,
          product_id: product?.id,
          check_status: found,
          order:addonItem?.order ?? null,
          quantity: found
            ? add.find((x) => x.product_addon_id == addonItem.id).quantity
            : 0,
          total: function () {
            return this.quantity * this.price;
          },
        };
        
        addonsInfo.push(data);
        }

       }
      }
      );
      if(has_addons){
        arryAddonLimit.push(objAddonLimit);
      }
    }
    });
    sortedByNumber(arryAddonLimit)
    addonsInfo = sortedByNumber(addonsInfo)
  }

  return { total, arryAddonLimit, addonsInfo };
};
